module.exports = __webpack_public_path__ + "static/img/1.1740e98.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/200204/1.jpeg
// module id = jEws
// module chunks = 1